// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { NavLink } from 'react-router-dom'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'
import Form from '../../components/Form'
import InputImage from '../../components/InputImage'
import Input from '../../components/Input'
import Label from '../../components/Label'
import Links from '../../components/Links'
import Warning from '../Warning'

// Normalze
import * as normalize from '../../constants/normalize'

// Validate
import { email, required, minLength13, validatePassword } from '../../constants/validate'

// Actions
import { profile } from './actions'

class ProfilePage extends Component {
  handleFormSubmit = (reduxFormData) => {
    const { profile } = this.props

    return profile(reduxFormData)
  }

  render() {
    const { localLoading, user: { admin, lawFirmId, manager, image, role }, handleSubmit } = this.props
    let options = [
      { 'to': '/perfil/alterar-informacoes', 'text': 'Alterar Informações' },
    ]

    if ((manager && !lawFirmId) || admin) {
      options = [...options, { 'to': '/perfil/pagamento', 'text': 'Pagamento' }]
    }

    return (
      <div className="profile">
        <div className="profile__header">
          <Breadcrumb marginBottom={0} routes={['perfil', 'alterar-informações']} />
          <Links options={options} />
        </div>
        <Warning gutterBottom={20} />
        <Form autoComplete="false" onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Row>
            <Col>
              <Label gutterTop={0}>Dados Básicos</Label>
            </Col>
            <Col md="25%">
              <Field
                md
                name="file"
                label="Imagem"
                component={InputImage}
                size='2'
                image={image + '/big'}
                accept=".jpg, .jpeg, .png"
                gutter={25} />
            </Col>
            <Col md="75%">
              <Row>
                <Col md="50%">
                  <Field
                    name="name"
                    label="Nome"
                    component={Input}
                    gutter={25}
                    validate={required} />
                </Col>
                <Col md="50%">
                  <Field
                    name="surname"
                    label="Sobrenome"
                    component={Input}
                    gutter={25}
                    validate={required} />
                </Col>
              </Row>
              <Row>
                <Col md="50%">
                  <Field
                    name="phone"
                    component={Input}
                    type="tel"
                    label="Celular"
                    gutter={25}
                    normalize={normalize.phone}
                    validate={[required, minLength13]} />
                </Col>
                <Col md="50%">
                  <Field
                    name="email"
                    label="Email"
                    component={Input}
                    gutter={25}
                    validate={[email, required]} />
                </Col>
              </Row>
            </Col>
          </Row>
          {role === 'company' && !lawFirmId &&
            <Row>
              <Col>
                <Label>Dados do Grupo</Label>
              </Col>
              <Col md="100%">
                <Field
                  name="group"
                  label="Nome"
                  component={Input}
                  type="text"
                  gutter={25}
                  disabled />
              </Col>
            </Row>
          }
          {role === 'company' && lawFirmId &&
            <Row>
              <Col>
                <Label>Dados do Escritório</Label>
              </Col>
              <Col md="100%">
                <Field
                  name="lawFirm"
                  label="Nome"
                  component={Input}
                  type="text"
                  gutter={25}
                  disabled />
              </Col>
            </Row>
          }
          <Row>
            <Col>
              <Label>Dados de Segurança (Opcional)</Label>
            </Col>
            <Col md="50%">
              <Field
                name="password"
                component={Input}
                type="password"
                label="Nova Senha"
                gutter={25}
                autoComplete="new-password"
                validate={validatePassword} />
            </Col>
            <Col md="50%">
              <Field
                name="passwordConfirm"
                component={Input}
                type="password"
                label="Confirmar Nova Senha"
                gutter={25}
                validate={validatePassword} />
            </Col>
          </Row>
          <Row>
            <Col sm="100%" md="50%" lg="25%">
              <Button
                localLoading={localLoading}
                type="submit"
                gutterTop={30}>
                Salvar Alterações
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const reduxFormValidate = (values) => {
  const errors = {}

  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Senhas não coincidem.'
  }

  if (['semprocesso', 'sem processo', 'comacordo', 'com acordo'].indexOf(values.password) !== -1) {
    errors.password = 'Senha inválida por questões de segurança.'
  }

  return errors
}

ProfilePage = reduxForm({
  form: 'profile',
  validate: reduxFormValidate,
})(ProfilePage);

ProfilePage = connect(state => {
  return {
    initialValues: {
      name: state.auth.user.name,
      surname: state.auth.user.surname,
      email: state.auth.user.email,
      phone: state.auth.user.phone,
      group: state.auth.user.group,
      groupId: state.auth.user.groupId,
      lawFirm: state.auth.user.lawFirm,
      lawFirmId: state.auth.user.lawFirmId
    },
    localLoading: state.app.localLoading,
    user: state.auth.user
  }
}, { profile })(ProfilePage)

export default ProfilePage
